import {Injectable} from '@angular/core';
import {ReportesRequestService} from './request/reportes-request.service';
import {DatePipe} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ServicioComprobanteInformeService {

  constructor(private requestUrl: ReportesRequestService,
    private datePipe: DatePipe) { }

  async getSedes(objetoParametros: FiltroComprobanteInforme) {
    try {
      let response = await this.requestUrl.getFilterRequest(
        'reporte-comprobante/sede',
        [objetoParametros.codigoBaseDatos, {
          uncoSede: objetoParametros.uncoSede.split(",")[0]
        }]
      );
      return response;
    } catch (e) {
      console.log(`ServicioComprobanteInformeService.getSedes() ${e}`);
    }
    return null;
  }

  async getCajeros(objetoParametros: FiltroComprobanteInforme) {
    try {
      let response = await this.requestUrl.getFilterRequest(
        'reporte-comprobante/cajero',
        [objetoParametros.codigoBaseDatos, {
          uncoSede: objetoParametros.uncoSede.split(",")[0],
          uncoUsuario: objetoParametros.uncoLogin.split(",")[0]
        }]
      );
      return response;
    } catch (e) {
      console.log(`ServicioComprobanteInformeService.getCajeros() ${e}`);
    }
    return null;
  }

  async getEntidadEmpresarial(objetoParametros: FiltroComprobanteInforme) {
    try {
      const response = await this.requestUrl.getRequest(
        'entidad-empresarial/datos-entidad-sp',
        [objetoParametros.codigoBaseDatos, { unco_sede: objetoParametros.uncoSede }]
      );
      return response;

    } catch (e) {
      alert(e);
      console.log(`ServicioComprobanteInformeService.getEntidadEmpresarial() ${e}`);
    }
    return null;
  }

  async getInformacionUsuario(objetoParametros: FiltroComprobanteInforme) {
    try {
      return await this.requestUrl.getRequest(
        'informacion-usuario/datos',
        [objetoParametros.codigoBaseDatos, {
          unco_login: objetoParametros.uncoLogin.split(',')[0]
        }]
      );

    } catch (e) {
      alert(e);
      console.log(`ServicioComprobanteInformeService.getInformacionUsuario() ${e}`);
    }
    return null;
  }

  async getInformacionComprobantes(objetoParametros: FiltroComprobanteInforme) {
    try {
      const response = await this.requestUrl.getRequest(
        'reporte-comprobante-informe-diario/comprobantes',
        [objetoParametros.codigoBaseDatos, {
          ld_fcha_incl: this.datePipe.transform(objetoParametros.fecha, 'yyyy-MM-dd'),
          lc_unco_sede: objetoParametros.uncoSede,
          lc_unco_lgn: objetoParametros.uncoLogin
        }]
      );
      return response;

    } catch (e) {
      alert(e);
      console.log(`ServicioComprobanteInformeService.getInformacionComprobantes() ${e}`);
    }
    return null;
  }

  async getInformacionComprobantesResumen(objetoParametros: FiltroComprobanteInforme) {
    try {
      const response = await this.requestUrl.getRequest(
        'reporte-comprobante-informe-diario/comprobantes-resumen',
        [objetoParametros.codigoBaseDatos, {
          ld_fcha_incl: this.datePipe.transform(objetoParametros.fecha, 'yyyy-MM-dd'),
          lc_unco_sede: objetoParametros.uncoSede,
          lc_unco_lgn: objetoParametros.uncoLogin
        }]
      );
      return response;

    } catch (e) {
      alert(e);
      console.log(`ServicioComprobanteInformeService.getInformacionComprobantesResumen() ${e}`);
    }
    return null;
  }

  async getResumenServicio(objetoParametros: FiltroComprobanteInforme) {
    try {
      const response = await this.requestUrl.getRequest(
        'reporte-comprobante-informe-diario/resumen-servicio',
        [objetoParametros.codigoBaseDatos, {
          ld_fcha_incl: this.datePipe.transform(objetoParametros.fecha, 'yyyy-MM-dd'),
          lc_unco_sede: objetoParametros.uncoSede,
          lc_unco_lgn: objetoParametros.uncoLogin
        }]
      );
      return response;

    } catch (e) {
      alert(e);
      console.log(`ServicioComprobanteInformeService.getResumenServicio() ${e}`);
    }
    return null;
  }
}

export interface Sedes {
  unco: number;
  descripcionCorta: string;
  descripcion: string;
}

export interface Cajero {
  unco: number;
  nombre: string;
}

export interface FiltroComprobanteInforme {
  codigoBaseDatos: string;
  fecha?: Date;
  uncoSede: string;
  uncoLogin?: string;
}

export interface DatosBaseEntity {
  codigoBaseDatos: string;
  uncoSede: number;
  uncoLogin: number;
};

export interface EntidadEmpresarial {
  identificacionTributaria: string;
  digitoVerificacion: string;
  descripcion: string;
  direccion: string;
  telefono: string;
  logoUrl: string;
  codigoPrestador: string;
}

export interface InformacionUsuario {
  nombreUsuario: string;
  codigoBarrasImprime: string;
}

export interface InformacionComprobante {
  consecutivo: string;
  fecha: string;
  consecutivoRf: string;
  empresa: string;
  nombreAfiliado: string;
  IDAfiliado: string;
  formaPago: string;
  estadoRegistro: string;
  usuario: string;
  equipo: string;
  valorServicioDetalle: number;
  valorSuministroDetalle: number;
  valorFormaPagoDetalle: number;
  valorEpsDetalle: number;
  uncoFormaPago: number;
  uncoDcm: number;
  codigo: number;
  valorIva: number;
  uncoParametrosLey: number;
  nombreMaquina?: string;
}

export interface ResumenServicio {
  codigoLinea: string;
  lineaProducto: string;
  cantidad: number;
  valorTotal: number;
  parcialIva: number;
  valorPorcentaje: number;
  valorTotalG: number;
}

export interface ListaComprobantesUsuario {
  [usuario: string]: InformacionComprobante[]
}

export interface SumaComprobantesUsuario {
  [usuario: string]: TotalSumaComprobantes
}

export interface TotalSumaComprobantes {
  totalValorServicios: number;
  totalValorSuministros: number;
  totalValorFactura: number;
  totalDescuentos: number;
  totalEfectivo: number;
  totalVentasCredito: number;
  totalValorIva: number;
  totalValor?: number;
}

export class SumaResumenServicio {
  valorTotal: number = 0;
  iva: number = 0;
  valorTotalG: number = 0;
}
